import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import WebViewer, { WebViewerInstance } from "@pdftron/webviewer";
import { Signing_HOST_API, getSigningFileUrl } from "../config";
import { Container } from "@cloudscape-design/components";
import TopNavigation from "@cloudscape-design/components/top-navigation";
import axiosInstance from "../context/axios";
import { captureException } from "@sentry/react";
import SigningLoader from "./signing-loader";
import { disabledElements } from "../components/pdftron-viewer/pdftron-viewer";

export function SigningDocument() {
  const [searchParams] = useSearchParams();
  const viewer = useRef<HTMLDivElement>(null);
  const [instance, setInstance] = useState<WebViewerInstance | undefined>(
    undefined
  );
  const [xfdfString, setXfdfString] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(Signing_HOST_API + "?" + searchParams.toString(), {
        headers: { "X-Org-ID": searchParams.get("org_id") ?? "-1" },
      })
      .then(async (response) => {
        if (response?.status === 200) setXfdfString(response.data.xfdfString);
        else if (window.location.host === "localhost:3000")
          setXfdfString(
            '<?xml version="1.0" encoding="UTF-8"?><xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve"><pdf-info xmlns="http://www.pdftron.com/pdfinfo" version="2" import-version="4"><ffield type="Tx" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_firstName"><font name="Arial" size="8"></font></ffield><ffield type="Tx" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_lastName"><font name="Arial" size="8"></font></ffield><ffield type="Tx" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_text_field_0"><font name="Arial" size="8"></font></ffield><ffield type="Btn" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_check_box_0"><font name="Arial" size="8"></font></ffield><ffield type="Sig" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_signature"><font name="Arial" size="8"></font></ffield><widget field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_firstName" name="cbf69069-cff1-425f-5b2e-8f0e6c4d7951" modified-date="D:20240118175237-06&apos;00&apos;" page="1"><rect x1="307.35" x2="482.378" y1="740.197" y2="775.203"></rect><border style="solid"></border><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data></widget><widget field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_lastName" name="df31550d-14d4-d74e-c5ad-4797ed12d657" modified-date="D:20240118175237-06&apos;00&apos;" page="1"><rect x1="308.05" x2="483.078" y1="692.584" y2="727.59"></rect><border style="solid"></border><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data></widget><widget field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_text_field_0" name="ee7abe38-af8a-3090-c81e-20773353f8d9" modified-date="D:20240118175249-06&apos;00&apos;" page="1"><rect x1="398.508" x2="522.1146" y1="659.9881" y2="684.7094"></rect><border style="solid"></border><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;recipientId&quot;:&quot;7ba96fe2-691e-48b3-b1ab-d77769c0cc83&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data></widget><widget appearance="Off" field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_check_box_0" name="c21b1013-a334-b728-d83c-b0a7e374a95a" modified-date="D:20240118175249-06&apos;00&apos;" page="1"><rect x1="472.1775" x2="480.0884" y1="614.9952" y2="622.9061"></rect><border style="solid"></border><appearances><aappearance name="Off"></aappearance><aappearance name="On"></aappearance></appearances><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;recipientId&quot;:&quot;7ba96fe2-691e-48b3-b1ab-d77769c0cc83&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data><captions Normal="n"></captions></widget><widget appearance="_DEFAULT" field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_signature" name="f7c38c7d-34e8-4e3d-67aa-0f5a8dc7897d" modified-date="D:20240118175249-06&apos;00&apos;" page="1"><rect x1="443.9952" x2="567.6019" y1="561.1027" y2="585.824"></rect><border style="solid"></border><appearances><aappearance name="_DEFAULT"><Normal>data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjEuMWMqnEsAAAANSURBVBhXY/j//z8DAAj8Av6IXwbgAAAAAElFTkSuQmCC</Normal></aappearance></appearances><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;recipientId&quot;:&quot;7ba96fe2-691e-48b3-b1ab-d77769c0cc83&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data></widget></pdf-info><fields><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_firstName"><value>ravi teja</value></field><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_lastName"><value>ravinoothala</value></field><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_text_field_0"><value>Standard_Text Field</value></field><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_check_box_0"><value>Off</value></field><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_signature"><value></value></field></fields><annots></annots><pages><defmtx matrix="1,0,0,-1,0,792"></defmtx></pages></xfdf>'
          );
        else navigate("error");
        setIsLoading(false);
      })
      .catch((error) => {
        captureException(error);
        console.error({ error });
        if (window.location.host === "localhost:3000")
          setXfdfString(
            '<?xml version="1.0" encoding="UTF-8"?><xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve"><pdf-info xmlns="http://www.pdftron.com/pdfinfo" version="2" import-version="4"><ffield type="Tx" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_firstName"><font name="Arial" size="8"></font></ffield><ffield type="Tx" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_lastName"><font name="Arial" size="8"></font></ffield><ffield type="Tx" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_text_field_0"><font name="Arial" size="8"></font></ffield><ffield type="Btn" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_check_box_0"><font name="Arial" size="8"></font></ffield><ffield type="Sig" name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_signature"><font name="Arial" size="8"></font></ffield><widget field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_firstName" name="cbf69069-cff1-425f-5b2e-8f0e6c4d7951" modified-date="D:20240118175237-06&apos;00&apos;" page="1"><rect x1="307.35" x2="482.378" y1="740.197" y2="775.203"></rect><border style="solid"></border><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data></widget><widget field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_lastName" name="df31550d-14d4-d74e-c5ad-4797ed12d657" modified-date="D:20240118175237-06&apos;00&apos;" page="1"><rect x1="308.05" x2="483.078" y1="692.584" y2="727.59"></rect><border style="solid"></border><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data></widget><widget field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_text_field_0" name="ee7abe38-af8a-3090-c81e-20773353f8d9" modified-date="D:20240118175249-06&apos;00&apos;" page="1"><rect x1="398.508" x2="522.1146" y1="659.9881" y2="684.7094"></rect><border style="solid"></border><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;recipientId&quot;:&quot;7ba96fe2-691e-48b3-b1ab-d77769c0cc83&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data></widget><widget appearance="Off" field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_check_box_0" name="c21b1013-a334-b728-d83c-b0a7e374a95a" modified-date="D:20240118175249-06&apos;00&apos;" page="1"><rect x1="472.1775" x2="480.0884" y1="614.9952" y2="622.9061"></rect><border style="solid"></border><appearances><aappearance name="Off"></aappearance><aappearance name="On"></aappearance></appearances><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;recipientId&quot;:&quot;7ba96fe2-691e-48b3-b1ab-d77769c0cc83&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data><captions Normal="n"></captions></widget><widget appearance="_DEFAULT" field="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_signature" name="f7c38c7d-34e8-4e3d-67aa-0f5a8dc7897d" modified-date="D:20240118175249-06&apos;00&apos;" page="1"><rect x1="443.9952" x2="567.6019" y1="561.1027" y2="585.824"></rect><border style="solid"></border><appearances><aappearance name="_DEFAULT"><Normal>data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjEuMWMqnEsAAAANSURBVBhXY/j//z8DAAj8Av6IXwbgAAAAAElFTkSuQmCC</Normal></aappearance></appearances><trn-custom-data bytes="{&quot;required&quot;:&quot;&quot;,&quot;recipientId&quot;:&quot;7ba96fe2-691e-48b3-b1ab-d77769c0cc83&quot;,&quot;type&quot;:&quot;custom&quot;}"></trn-custom-data></widget></pdf-info><fields><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_firstName"><value>ravi teja</value></field><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_lastName"><value>ravinoothala</value></field><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_text_field_0"><value>Standard_Text Field</value></field><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_check_box_0"><value>Off</value></field><field name="7ba96fe2-691e-48b3-b1ab-d77769c0cc83_standard_fields_signature"><value></value></field></fields><annots></annots><pages><defmtx matrix="1,0,0,-1,0,792"></defmtx></pages></xfdf>'
          );
        else navigate("error");
        setIsLoading(false);
      });
  }, [searchParams]);

  useEffect(() => {
    if (viewer.current != null && !!xfdfString)
      WebViewer(
        {
          path: "/webviewer",
          licenseKey: process.env.REACT_APP_APRYSE_LICENSE_KEY,
        },
        viewer.current
      )
        .then((instance) => {
          const { documentViewer, annotationManager } = instance.Core;

          instance.UI.disableElements(disabledElements);
          instance.UI.disableElements(["toolsHeader"]);
          instance.UI.setFitMode(instance.UI.FitMode.FitWidth);
          instance.UI.showFormFieldIndicators();

          setInstance(instance);
          documentViewer.addEventListener("annotationsLoaded", async () => {
            const annots = annotationManager.getAnnotationsList();
            // remove annotations
            annotationManager.deleteAnnotations(annots);
            await annotationManager.importAnnotations(xfdfString);
          });
        })
        .catch((error) => {
          captureException(error);
          console.log({ error });
        });
  }, [xfdfString]);

  useEffect(() => {
    const fileKey = searchParams.get("file");
    if (!instance) return;
    if ("localhost" === window.location.hostname) {
      instance.UI.loadDocument("/sample.pdf");
    } else if (!!fileKey) {
      console.log(
        encodeURI(getSigningFileUrl(fileKey)) + "?" + searchParams.toString()
      );
      instance.UI.loadDocument(
        encodeURI(getSigningFileUrl(fileKey)) + "?" + searchParams.toString(),
        {
          withCredentials: true,
        }
      );
    }
  }, [instance]);

  if (!!isLoading) return <SigningLoader />;
  else
    return (
      <Container
        header={
          <TopNavigation
            identity={{
              href: "#",
              title: "",
              logo: {
                //pointing to logo image in public folder
                src: "/assets/White logo - no background.png",
                alt: "Incredable logo",
              },
            }}
            utilities={[
              {
                type: "button",
                variant: "primary-button",
                text: "Submit",
                onClick: async () => {
                  if (!instance) return;
                  const { annotationManager, Annotations } = instance.Core;
                  const annotList = annotationManager.getAnnotationsList();

                  // Validate the annotation, check if any required field is blank.
                  for (const annotation of annotList) {
                    if (
                      annotation instanceof
                      instance.Core.Annotations.SignatureWidgetAnnotation
                    ) {
                      if (
                        !annotation.getAssociatedSignatureAnnotation() // not null
                        //  && !!annotation.getCustomData("required") // and is required
                      ) {
                        window.alert(
                          "Please ensure all required fields (those marked in red and the signature field) are filled out."
                        );
                        return;
                      }
                    } else if (
                      annotation instanceof
                      instance.Core.Annotations.WidgetAnnotation
                    ) {
                      if (
                        !!annotation.getCustomData("required") &&
                        !annotation.getValue()
                      ) {
                        window.alert(
                          "Please ensure all required fields (those marked in red and the signature field) are filled out."
                        );
                        return;
                      }
                    }
                  }

                  // remove the annotation border before submitting.
                  annotList.forEach((annotation) => {
                    if (
                      annotation instanceof
                      instance.Core.Annotations.WidgetAnnotation
                    ) {
                      annotation.border = new Annotations.Border({
                        color: new Annotations.Color(0, 0, 0, 0),
                        width: 0,
                        style: "none",
                      });
                    }
                  });

                  // redraw annotation after removing border
                  try {
                    await annotationManager.drawAnnotationsFromList(annotList);
                  } catch (error) {
                    captureException(error);
                    console.log(error);
                  }

                  // export xfdf string and send to server for signing.
                  const xfdfString = await annotationManager.exportAnnotations({
                    widgets: true,
                    fields: true,
                    links: false,
                    useDisplayAuthor: false,
                    generateInlineAppearances: true,
                  });
                  console.log({ xfdfString });
                  await axiosInstance({
                    method: "post",
                    url: Signing_HOST_API + "?" + searchParams.toString(),
                    headers: {
                      "Content-Type": "text/plain",
                      "X-Org-ID": searchParams.get("org_id") ?? "-1",
                    },
                    data: xfdfString,
                  });
                  navigate("/signing/success");
                },
              },
              {
                type: "button",

                text: "Download PDF",
                onClick: async () => {
                  if (!instance) return;
                  instance.UI.downloadPdf({ includeAnnotations: true });
                },
              },
            ]}
          />
        }
      >
        {(!!searchParams.has("file") ||
          window.location.host === "localhost:3000") && (
          <div
            ref={viewer}
            style={{
              height: `calc(100vh - 100px)`,
            }}
          />
        )}
        {!searchParams.has("file") && <h1>No file found</h1>}
      </Container>
    );
}
